import { Property } from '@clooper/core';
import { Component } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-published-modal',
  templateUrl: './published-modal.component.html',
  styleUrls: ['./published-modal.component.scss']
})
export class PublishedModalComponent  {
  propertyDetails: Property;

  constructor(public bsModalRef: BsModalRef) {}

}
